import { Paging } from './types'

export const CryptoWithDestinationTag = {
  XRP: 'XRP',
  ALGO: 'ALGO',
}

type Currency = {
  code: string
  name: string
  icon: string
}

export interface AddCryptoAddressResponse {
  name: string
  address: string
  destinationTag?: string
  protocol?: string
  currency: Currency
  reason: string
  creator: string
  dateCreated: string | number
  uuid: string
  paging?: Paging
}

export interface WhitelistingCryptoAddress {
  uuid: string
  address: string
  name: string
  protocol: string
}
